import styled from 'styled-components'

import { spaces } from '@/config/global-parameters'

import { IGanadorWithData } from '../types/ganadores'
import ByListSummary from './ByListSummary'
import GanadoresGraph from './GanadoresGraph'

interface IGanadoresSummary {
  className?: string
  ganadores: IGanadorWithData[]
  isIFrame?: boolean
  candidatosWithData: IGanadorWithData[]
}

const GanadoresSummary = ({
  candidatosWithData,
  className,
  ganadores,
  isIFrame = false,
}: IGanadoresSummary) => (
  <Wrapper className={className}>
    <GanadoresGraph
      ganadores={ganadores}
      nRowsMobile={isIFrame ? 4 : 3}
      popoverMode={isIFrame ? 'horizontal' : undefined}
      popoverPlace={isIFrame ? 'bottom' : undefined}
    />
    <ByListSummary
      allCandidates={candidatosWithData}
      candidates={ganadores}
    />
  </Wrapper>
)

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spaces.xs};
`

export default GanadoresSummary
